//audio files
import Low_Bb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-Bb.mp3";
import Low_B from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-B.mp3";
import Low_C from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-C.mp3";
import Low_Db from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-Db.mp3";
import Low_D from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-D.mp3";
import Low_Eb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-Eb.mp3";
import Low_E from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-E.mp3";
import Low_F from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-F.mp3";
import Low_Gb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Low-Gb.mp3";
import Middle_G from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-G.mp3";
import Middle_Ab from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-Ab.mp3";
import Middle_A from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-A.mp3";
import Middle_Bb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-Bb.mp3";
import Middle_B from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-B.mp3";
import Middle_C from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-C.mp3";
import Middle_Db from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-Db.mp3";
import Middle_D from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-D.mp3";
import Middle_Eb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-Eb.mp3";
import Middle_E from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-E.mp3";
import Middle_F from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-F.mp3";
import Middle_Gb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/Middle-Gb.mp3";
import High_G from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-G.mp3";
import High_Ab from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-Ab.mp3";
import High_A from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-A.mp3";
import High_Bb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-Bb.mp3";
import High_B from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-B.mp3";
import High_C from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-C.mp3";
import High_Db from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-Db.mp3";
import High_D from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-D.mp3";
import High_Eb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-Eb.mp3";
import High_E from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-E.mp3";
import High_F from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-F.mp3";
import High_Gb from "../EARTRAINING/all_chromatic_scales/alto_sax_chromatic_scale/High-Gb.mp3";

//interval images
import Low_Bb_Image from "../app/images/treble-clef-notes/Low-Bb.png"
import Low_B_Image from "../app/images/treble-clef-notes/Low-B.png";
import Low_C_Image from "../app/images/treble-clef-notes/Low-C.png";
import Low_Db_Image from "../app/images/treble-clef-notes/Low-Csharp.png";
import Low_D_Image from "../app/images/treble-clef-notes/Low-D.png";
import Low_Eb_Image from "../app/images/treble-clef-notes/Low-Eb.png";
import Low_E_Image from "../app/images/treble-clef-notes/Low-E.png";
import Low_F_Image from "../app/images/treble-clef-notes/Low-F.png";
import Low_Fsharp_Image from "../app/images/treble-clef-notes/Low-Fsharp.png";
import Middle_G_Image from "../app/images/treble-clef-notes/Middle-G.png";
import Middle_Gsharp_Image from "../app/images/treble-clef-notes/Middle-Gsharp.png";
import Middle_A_Image from "../app/images/treble-clef-notes/Middle-A.png";
import Middle_Bb_Image from "../app/images/treble-clef-notes/Middle-Bb.png";
import Middle_B_Image from "../app/images/treble-clef-notes/Middle-B.png";
import Middle_C_Image from "../app/images/treble-clef-notes/Middle-C.png";
import Middle_Csharp_Image from "../app/images/treble-clef-notes/Middle-Csharp.png";
import Middle_D_Image from "../app/images/treble-clef-notes/Middle-D.png";
import Middle_Eb_Image from "../app/images/treble-clef-notes/Middle-Eb.png";
import Middle_E_Image from "../app/images/treble-clef-notes/Middle-E.png";
import Middle_F_Image from "../app/images/treble-clef-notes/Middle-F.png";
import Middle_Fsharp_Image from "../app/images/treble-clef-notes/Middle-Fsharp.png";
import High_G_Image from "../app/images/treble-clef-notes/High-G.png";
import High_Ab_Image from "../app/images/treble-clef-notes/High-Ab.png";
import High_A_Image from "../app/images/treble-clef-notes/High-A.png";
import High_Bb_Image from "../app/images/treble-clef-notes/High-Bb.png";
import High_B_Image from "../app/images/treble-clef-notes/High-B.png";
import High_C_Image from "../app/images/treble-clef-notes/High-C.png";
import High_Csharp_Image from "../app/images/treble-clef-notes/High-Csharp.png";
import High_D_Image from "../app/images/treble-clef-notes/High-D.png";
import High_Eb_Image from "../app/images/treble-clef-notes/High-Eb.png";
import High_E_Image from "../app/images/treble-clef-notes/High-E.png";
import High_F_Image from "../app/images/treble-clef-notes/High-F.png";
import High_Fsharp_Image from "../app/images/treble-clef-notes/High-Fsharp.png";

export const AltoSaxChromaticScaleArray = [
  {
    image: Low_Bb_Image,
    index: 0,
    name: "Low Bb",
    audio_file: new Audio(Low_Bb),
  },
  {
    image: Low_B_Image,
    index: 1,
    name: "Low B",
    audio_file: new Audio(Low_B),
  },
  {
    image: Low_C_Image,
    index: 2,
    name: "Low C",
    audio_file: new Audio(Low_C),
  },
  {
    image: Low_Db_Image,
    index: 3,
    name: "Low Db",
    audio_file: new Audio(Low_Db),
  },
  {
    image: Low_D_Image,
    index: 4,
    name: "Low D",
    audio_file: new Audio(Low_D),
  },
  {
    image: Low_Eb_Image,
    index: 5,
    name: "Low Eb",
    audio_file: new Audio(Low_Eb),
  },
  {
    image: Low_E_Image,
    index: 6,
    name: "Low E",
    audio_file: new Audio(Low_E),
  },
  {
    image: Low_F_Image,
    index: 7,
    name: "Low F",
    audio_file: new Audio(Low_F),
  },
  {
    image: Low_Fsharp_Image,
    index: 8,
    name: "Low F#",
    audio_file: new Audio(Low_Gb),
  },
  {
    image: Middle_G_Image,
    index: 9,
    name: "Middle G",
    audio_file: new Audio(Middle_G),
  },
  {
    image: Middle_Gsharp_Image,
    index: 10,
    name: "Middle G#",
    audio_file: new Audio(Middle_Ab),
  },
  {
    image: Middle_A_Image,
    index: 11,
    name: "Middle A",
    audio_file: new Audio(Middle_A),
  },
  {
    image: Middle_Bb_Image,
    index: 12,
    name: "Middle Bb",
    audio_file: new Audio(Middle_Bb),
  },
  {
    image: Middle_B_Image,
    index: 13,
    name: "Middle B",
    audio_file: new Audio(Middle_B),
  },
  {
    image: Middle_C_Image,
    index: 14,
    name: "Middle C",
    audio_file: new Audio(Middle_C),
  },
  {
    image: Middle_Csharp_Image,
    index: 15,
    name: "Middle C#",
    audio_file: new Audio(Middle_Db),
  },
  {
    image: Middle_D_Image,
    index: 16,
    name: "Middle D",
    audio_file: new Audio(Middle_D),
  },
  {
    image: Middle_Eb_Image,
    index: 17,
    name: "Middle Eb",
    audio_file: new Audio(Middle_Eb),
  },
  {
    image: Middle_E_Image,
    index: 18,
    name: "Middle E",
    audio_file: new Audio(Middle_E),
  },
  {
    image: Middle_F_Image,
    index: 19,
    name: "Middle F",
    audio_file: new Audio(Middle_F),
  },
  {
    image: Middle_Fsharp_Image,
    index: 20,
    name: "Middle F sharp",
    audio_file: new Audio(Middle_Gb),
  },
  {
    image: High_G_Image,
    index: 21,
    name: "High G",
    audio_file: new Audio(High_G),
  },
  {
    image: High_Ab_Image,
    index: 22,
    name: "High Ab",
    audio_file: new Audio(High_Ab),
  },
  {
    image: High_A_Image,
    index: 23,
    name: "High A",
    audio_file: new Audio(High_A),
  },
  {
    image: High_Bb_Image,
    index: 24,
    name: "High Bb",
    audio_file: new Audio(High_Bb),
  },
  {
    image: High_B_Image,
    index: 25,
    name: "High B",
    audio_file: new Audio(High_B),
  },
  {
    image: High_C_Image,
    index: 26,
    name: "High C",
    audio_file: new Audio(High_C),
  },
  {
    image: High_Csharp_Image,
    index: 27,
    name: "High C sharp",
    audio_file: new Audio(High_Db),
  },
  {
    image: High_D_Image,
    index: 28,
    name: "High D",
    audio_file: new Audio(High_D),
  },
  {
    image: High_Eb_Image,
    index: 29,
    name: "High Eb",
    audio_file: new Audio(High_Eb),
  },
  {
    image: High_E_Image,
    index: 30,
    name: "High E",
    audio_file: new Audio(High_E),
  },
  {
    image: High_F_Image,
    index: 31,
    name: "High F",
    audio_file: new Audio(High_F),
  },
  {
    image: High_Fsharp_Image,
    index: 32,
    name: "High F sharp",
    audio_file: new Audio(High_Gb),
  },
];
